import { useEffect, useRef, useState } from "react";

interface Tab {
  id: string;
  label: string;
  icon: string;
}

const tabs: Tab[] = [
  { id: "philosophy", label: "理念・概要", icon: "ri-plant-line" },
  { id: "videos", label: "動画講座", icon: "ri-play-circle-line" },
  { id: "kits", label: "教材キット", icon: "ri-box-3-line" },
  { id: "reviews", label: "レビュー", icon: "ri-star-line" },
  { id: "faq", label: "よくある質問", icon: "ri-question-line" },
];

interface Props {
  activeTab: string;
  onTabChange: (id: string) => void;
}

export default function ProviderTabNav({ activeTab, onTabChange }: Props) {
  const [sticky, setSticky] = useState(false);
  const navRef = useRef<HTMLDivElement>(null);
  const [top, setTop] = useState(0);

  useEffect(() => {
    if (navRef.current) {
      setTop(navRef.current.getBoundingClientRect().top + window.scrollY);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (navRef.current) {
        const offsetTop = navRef.current.getBoundingClientRect().top;
        setSticky(offsetTop <= 64);
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [top]);

  return (
    <div ref={navRef} className={`z-30 bg-white border-b border-stone-100 transition-all duration-300 ${sticky ? "sticky top-16" : ""}`}>
      <div className="max-w-screen-xl mx-auto px-4 md:px-8">
        <div className="flex overflow-x-auto scrollbar-hide gap-0">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex items-center gap-2 px-5 py-4 text-sm font-sans whitespace-nowrap cursor-pointer border-b-2 transition-all duration-300 ${
                activeTab === tab.id
                  ? "border-teal text-teal font-medium"
                  : "border-transparent text-charcoal/50 hover:text-charcoal hover:border-stone-300"
              }`}
            >
              <i className={`${tab.icon} text-base`} />
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
